// removed by extract-text-webpack-plugin
module.exports = {"stepPanel":"Introduction__stepPanel___2Jbrw stepPanel__stepPanel___1Vrm5 layout__panel___vsQZV"};


//////////////////
// WEBPACK FOOTER
// ./src/introduction/components/Introduction.css
// module id = 760
// module chunks = 0